import { IoIosArrowDroprightCircle } from "react-icons/io";
import {
  CONTACT_US,
  YOUR_TRUSTED_PARTNER_IN_GLOBAL_MARITIME_SOLUTIONS,
} from "../../constants/translations";
import scrollToTop from "../../hybrids/functions/scrollToTop";
import { CONTACT_US_ROUTE } from "../../routes/routes";

import { Link } from "react-router-dom";
import heroBannerImg from "../../asset/images/home/hero-banner.png";
import introLogoImg from "../../asset/images/home/logo-hero.png";
const Intro = () => {
  return (
    <section className="intro-section">
      <div className="intro-texts">
        <div className="content-wrapper">
          <img src={introLogoImg} alt="DalBahr" width={181} height={125} />
          <h1 className="main-title">
            {YOUR_TRUSTED_PARTNER_IN_GLOBAL_MARITIME_SOLUTIONS}
          </h1>
          <Link
            to={CONTACT_US_ROUTE}
            onClick={scrollToTop}
            className="main-btn hero-btn"
          >
            {CONTACT_US}
            <IoIosArrowDroprightCircle />
          </Link>
        </div>
      </div>
      <div className="intro-img">
        <img src={heroBannerImg} alt="Ship" />
      </div>
    </section>
  );
};

export default Intro;
